import { createSlice } from "@reduxjs/toolkit";

import {
  fetchCustomFieldValues,
  saveCustomFieldValues,
} from "./customFieldValuesActions";

const key = (entityType, entityId) => `${entityType}:${entityId}`;

const customFieldValuesSlice = createSlice({
  name: "customFieldValues",
  initialState: { valuesByKey: {}, isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomFieldValues.fulfilled, (state, { payload }) => {
        state.valuesByKey[key(payload.entityType, payload.entityId)] =
          payload.values;
      })
      .addCase(saveCustomFieldValues.fulfilled, (state, { payload }) => {
        state.valuesByKey[key(payload.entityType, payload.entityId)] =
          payload.values;
      });
  },
});

export default customFieldValuesSlice.reducer;
